import { CalendarViewTypeEnum } from 'owa-calendar-view-type';
import { getSelectedViewType } from 'owa-calendar-module-store';
import { default as getCurrentColumnWidth } from './getCurrentColumnWidth';
import { CalendarLayoutColumnConstants } from '../constants';

export function shouldShowWeekDayTemp() {
    const currentColumnWidth = getCurrentColumnWidth();

    if (getSelectedViewType() === CalendarViewTypeEnum.Monthly) {
        return currentColumnWidth > CalendarLayoutColumnConstants.shouldShowWeekDayTemp_MONTH;
    }
    return currentColumnWidth > CalendarLayoutColumnConstants.shouldShowWeekDayTemp_WEEK;
}
